import { Component, signal } from '@angular/core';
import { Section1Component } from './section-1/section-1.component';
import { Section2Component } from './section-2/section-2.component';
import { Section3Component } from './section-3/section-3.component';
import { Section5Component } from './section-5/section-5.component';
import { Section6Component } from './section-6/section-6.component';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { GlobalProperties } from '@shared/models/classes/GlobalProperties';
import { PmButtonComponent } from '@shared/components/pm-button/pm-button.component';
import { CommonModule } from '@angular/common';
import { LandingPageMenuConfig } from '../../classes/LandingPageMenuConfig';
import { PmPagesSliderComponent } from '../../components/pm-pages-slider/pm-pages-slider.component';
import { PmEmojiComponent } from '@shared/components/pm-emoji/pm-emoji.component';

@Component({
  selector: 'landing-page-view',
  imports: [
    Section1Component,
    Section2Component,
    Section3Component,
    Section5Component,
    Section6Component,
    HeaderComponent,
    FooterComponent,
    PmButtonComponent,
    CommonModule,
    PmPagesSliderComponent,
    PmEmojiComponent,
  ],
  templateUrl: './landing-page-view.component.html',
  styleUrl: './landing-page-view.component.scss',
})
export class LandingPageViewComponent extends GlobalProperties {
  returnPath = signal(null);
  isLastSection = signal(false);
  protected landingPageMenuConfig = new LandingPageMenuConfig();

  private _sections = 'section-1, section-2, section-3, section-5, section-6';
  readonly appHeaderSticky = signal(false);

  get emojiActions() {
    return this.landingPageMenuConfig!.LANDING_PAGE_MENU_CONFIG!.actions?.filter(
      (a) => a.type === 'EMOJI'
    );
  }

  onScroll(): void {
    const sections = Array.from(document.querySelectorAll(this._sections));
    const lastSection = sections[sections.length - 1] as HTMLElement;

    if (!lastSection) return;

    const rect = lastSection.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    this.isLastSection.set(rect.top <= viewportHeight / 2);
  }

  scrollToNextSection(): void {
    const sections = Array.from(document.querySelectorAll(this._sections));
    const currentScroll = window.scrollY;
    const nextSection = sections.find((sec) => {
      const rect = (sec as HTMLElement).getBoundingClientRect();
      const top = rect.top + window.scrollY;
      return top > currentScroll + 74; // appHeaderHeight + 10px marginesu
    });

    if (nextSection) {
      (nextSection as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  onPageScroll(distance: number) {
    this.appHeaderSticky.set(distance > 0);
  }
}
